import { render, staticRenderFns } from "./searchPage.vue?vue&type=template&id=495e8776&"
import script from "./searchPage.vue?vue&type=script&lang=js&"
export * from "./searchPage.vue?vue&type=script&lang=js&"
import style0 from "./searchPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports